import React, { useState } from "react";

import Sidebar from "../components/menu/sidebar";
import Topbar from "../components/menu/topbar";

const Layout = ({ header, children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed((previousState) => !previousState);
  };

  return (
    <div className={`app-shell${sidebarCollapsed ? " sidebar-collapsed" : ""}`}>
      <Sidebar collapsed={sidebarCollapsed} onToggleSidebar={toggleSidebar} />
      <Topbar />
      <div className="app-main">
        {header && <div>{header}</div>}
        <main>{children}</main>
      </div>
      <footer className="app-footer">
        <span>&copy; {new Date().getFullYear()} Textum</span>
        <div>
          <a href="#privacy">Política de privacidad</a>
          <a href="#terms">Términos de servicio</a>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
